import { AuthRepository } from "../../../../data/repository/auth/AuthRepository";
import { AccessToken, Auth, Message, Password } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";

export interface ChangePasswordUseCase {
  invoke: (password: Password) => Promise<ResponseState<Message>>;
}

export class ChangePasswordUseCaseImpl implements ChangePasswordUseCase {
  private authRepository: AuthRepository;

  constructor(authRepository: AuthRepository) {
    this.authRepository = authRepository;
  }

  async invoke(password: Password): Promise<ResponseState<Message>> {
    try {
      let response = await this.authRepository.changePassword(password);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
